import { Text, TextProps } from "@chakra-ui/react";
import React from "react";

export type RequiredAstriskProps = Omit<TextProps, "children">;

export const RequiredAstrisk: React.FC<RequiredAstriskProps> = (props) => {
  return (
    <Text as="span" color="red.600" fontSize="lg" paddingLeft={1} {...props}>
      *
    </Text>
  );
};
